import './romb.scss';

const AnimatedIcon = () => {
    return (
      <div className="animated-icon">
        <svg
          width="50"
          height="50"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="diamond"
        >
          <polygon
            points="50,10 90,50 50,90 10,50"
            stroke="#0095ff"
            strokeWidth="8"
            fill="none"
          />
        </svg>
      </div>
    );
  };
  
  export default AnimatedIcon;